import React from 'react';
import dayjs from 'dayjs';

import { Wrapper, Icon, Title, TimeLabel } from './elements';
import Spa08 from 'dc/Spa08';
import Spa16 from 'dc/Spa16';
import { useText } from 'common/hooks';

type Props = {
  readonly datetime: number;
};

export default function ChallengeStarted({
  datetime,
}: Props): React.ReactElement {
  const t = useText();

  return (
    <Wrapper>
      <Icon icon={'icon-trophy'} />
      <Spa08 />
      <Title>{t('challenge.latest_events.FeC005A.now_started')}</Title>
      <Spa16 />
      <TimeLabel color={'#546e7a'} icon={'icon-schedule'}>
        {dayjs(datetime).fromNow()}
      </TimeLabel>
    </Wrapper>
  );
}
